import { useQuery } from '@tanstack/react-query';
import { useNotifications } from '@weareopenr/component-library';
import { ErrorMessages } from 'src/api/constants';
import { getBrands } from 'src/api/getBrands/getBrands';
import { useUserTracking } from '../useUserTracking/useUserTracking';

export const useGetBrands = () => {
  const setNotification = useNotifications();
  const { captureException } = useUserTracking();
  return useQuery({
    queryKey: ['brands'],
    queryFn: getBrands,
    onError: (e: Error) => {
      setNotification({
        message: e.message,
        severity: 'error',
        description: ErrorMessages.CONTACT_ADMIN,
      });
      captureException(e);
    },
  });
};
